const BILLERAPI = {
    ADDBILLER: `users/signup`,
    GETBILLER: `users/users/role/Biller`,
    DELETEBILLER: (userId) => `users/user/${userId}`,
    EDITBILLER: (userId) => `users/user/${userId}`
}

export default BILLERAPI;